import React from 'react';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImageCard from './ImageCard';

const coreValuesData = [
  {
    title: 'Safety',
    description:
      'We prioritise safety above all else, ensuring a secure and controlled environment for every swimmer, at every level.',
  },
  {
    title: 'Commitment to Excellence',
    description:
      'We strive for excellence in our coaching, facilities, and programs, always aiming to deliver the highest standard of service.',
  },
  {
    title: 'Empowering Swimmers of All Levels',
    description:
      'We believe every swimmer, whether beginner or squad, should feel confident and supported to achieve their personal best.',
  },
  {
    title: 'Building a Strong Community',
    description:
      'We foster a welcoming and inclusive community where swimmers, families, and coaches build strong, lasting connections.',
  },
  {
    title: 'Encouraging Lifelong Health and Fitness',
    description:
      'We promote swimming as a lifelong skill that supports overall health, fitness, and wellbeing for all ages.',
  },
];

const CoreValues = () => {
  const theme = useTheme();

  const boxStyle = {
    p: 2,
    borderRadius: 2,
    boxShadow: 3,
    bgcolor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    mb: 2,
  };

  return (
    <Container sx={{ mt: 4, mb: 5 }}>
      {/* Heading */}
      <Typography
        variant="h2"
        gutterBottom
        sx={{ textAlign: 'center', color: theme.palette.primary.main, pt: 4 }}
      >
        Our Core Values
      </Typography>

      {/* Values + Images */}
      <Grid container spacing={4}>
        {/* Left Side: Static Images */}
        <Grid item xs={12} md={6}>
          <ImageCard
            src="/images/SJ_Gallery/LTS_1.jpg"
            alt="Core Values 1"
            height={400}
            objectFit="contain"
            objectPosition="center"
          />
          <ImageCard
            src="/images/SJ_Gallery/SQ_Su_4.jpg"
            alt="Core Values 2"
            height={400}
            objectFit="contain"
            objectPosition="center"
          />
        </Grid>

        {/* Right Side: Core Values Accordions */}
        <Grid item xs={12} md={6}>
          {coreValuesData.map((value, index) => (
            <Accordion key={index} sx={{ ...boxStyle }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.background.paper }} />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {value.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ bgcolor: '#f7f7f7', color: '#17204a', borderRadius: 2 }}>
                <Typography variant="body2">{value.description}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
};

export default CoreValues;